import React from 'react'
import { Link } from 'gatsby'

const BonsPlansJeunesListItem = ({ postIndex, postItem }) => {
	// Validation des props
	if (!postItem || typeof postItem !== 'object') {
		return (
			<li 
				className="bons-plans-jeunes-list-item-error"
				role="listitem"
				aria-label="Élément de bon plan invalide"
				aria-describedby="bons-plans-jeunes-item-error-description"
			>
				<div id="bons-plans-jeunes-item-error-description" className="visually-hidden">
					Élément de bon plan non disponible ou corrompu
				</div>
			</li>
		)
	}

	const { objectid, nom_dispositif, support_visuel, sous_thematique } = postItem

	// Validation des données essentielles
	if (!nom_dispositif || !objectid) {
		return (
			<li 
				className="bons-plans-jeunes-list-item-error"
				role="listitem"
				aria-label="Élément de bon plan incomplet"
				aria-describedby="bons-plans-jeunes-item-incomplete-description"
			>
				<div id="bons-plans-jeunes-item-incomplete-description" className="visually-hidden">
					Élément de bon plan avec informations manquantes
				</div>
			</li>
		)
	}

	// Fonction pour nettoyer le HTML et extraire le texte
	const cleanHtmlText = (htmlString) => {
		if (!htmlString || typeof htmlString !== 'string') {
			return ''
		}
		
		// Suppression des balises HTML pour l'accessibilité
		const cleanText = htmlString.replace(/<[^>]*>/g, '')
		
		// Retourner null si le texte est vide après nettoyage
		return cleanText.trim() || null
	}

	// Génération de l'URL de référence
	let nom_dispositif_ref = nom_dispositif.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, '').replace(/ /g, '-').replace(/[^\w-]+/g, '');
	nom_dispositif_ref = nom_dispositif_ref.trim() + '-' + objectid;

	// Nettoyage du titre pour l'accessibilité
	const cleanTitle = cleanHtmlText(nom_dispositif)
	const imageAlt = cleanTitle ? `${cleanTitle}${sous_thematique ? ` - ${sous_thematique}` : ''}` : 'Image du bon plan'
	const itemId = `bons-plans-jeunes-item-${postIndex !== undefined ? postIndex : 'unknown'}`

	return (
		<li 
			className="bons-plans-jeunes-list-item"
			role="listitem"
			aria-label={`Bon plan : ${cleanTitle || 'Sans titre'}`}
			id={itemId}
		>
			<Link 
				className="bons-plans-jeunes-list-item-link" 
				to={`/services-infos-pratiques/jeunesse/bons-plans-pour-les-jeunes/annuaire-bons-plans-jeunes/${nom_dispositif_ref}`}
				aria-labelledby={`${itemId}-title`}
				aria-describedby={sous_thematique ? `${itemId}-category` : undefined}
				tabIndex="0"
			>
				<div className="bons-plans-jeunes-list-item-content">
					<div 
						className="bons-plans-jeunes-list-item-content-picture"
						role="img"
						aria-label={imageAlt}
					>
						<img 
							alt={imageAlt} 
							src={support_visuel} 
							aria-hidden="true"
						/>
						{sous_thematique && (
							<p 
								className="bons-plans-jeunes-list-item-content-cateory"
								id={`${itemId}-category`}
								aria-label={`Catégorie : ${sous_thematique}`}
							>
								{sous_thematique}
							</p>
						)}
					</div>
					<div className="bons-plans-jeunes-list-item-content-info">
						{nom_dispositif && (
							<h2
								className="bons-plans-jeunes-list-item-content-title"
								id={`${itemId}-title`}
								dangerouslySetInnerHTML={{ __html: nom_dispositif }}
								aria-label={`Titre : ${cleanTitle}`}
							/>
						)}
					</div>
				</div>
			</Link>
		</li>
	)
}

export default BonsPlansJeunesListItem
